import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Button from 'components/common/buttons/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '../../../register-fa-icons';

const CurricularEquivalenceCard = ({ className, id, card }) => {
  return (
    <Link
      to={`curricular/${id}/edit`}
      className={`${className} card-100 card-body`}
      style={{ padding: '12px', paddingRight: '0px' }}
    >
      <div className="d-flex flex-row justify-space-between align-center">
        <div className="w-60 h-100 d-flex flex-direction-column">
          <p className="m-0 semi-bold d-flex flex-row align-center">
            <p className="m-0 semi-bold brown mr-2">Curriculo Origem:</p>
            <p className="m-0">
              {card?.grid_discipline?.grid?.curriculum?.name}
            </p>
          </p>
          <p className="m-0 semi-bold d-flex flex-row align-center">
            <p className="m-0 semi-bold brown mr-2">Etapa Origem:</p>
            <p className="m-0">{card?.grid_discipline?.grid?.name}</p>
          </p>
          <p className="m-0 semi-bold d-flex flex-row align-center">
            <p className="m-0 semi-bold brown mr-2">Disciplina Origem:</p>
            <p className="m-0">{card?.grid_discipline?.discipline?.nome}</p>
          </p>
        </div>
        <div className="w-60 h-100 d-flex flex-direction-column">
          <p className="m-0 semi-bold d-flex flex-row align-center">
            <p className="m-0 semi-bold brown mr-2">Curriculo Equivalente:</p>
            <p className="m-0">
              {card?.equivalent_grid_discipline?.grid?.curriculum?.name}
            </p>
          </p>
          <p className="m-0 semi-bold d-flex flex-row align-center">
            <p className="m-0 semi-bold brown mr-2">Etapa Equivalente:</p>
            <p className="m-0">
              {card?.equivalent_grid_discipline?.grid?.name}
            </p>
          </p>
          <p className="m-0 semi-bold d-flex flex-row align-center">
            <p className="m-0 semi-bold brown mr-2">Disciplina Equivalente:</p>
            <p className="m-0">
              {card?.equivalent_grid_discipline?.discipline?.nome}
            </p>
          </p>
        </div>
        <div className="w-40 h-100 d-flex justify-flex-end">
          <FontAwesomeIcon icon="edit" className="primary mr-2" />
        </div>
      </div>
    </Link>
  );
};

CurricularEquivalenceCard.propTypes = {
  className: PropTypes.string,
  nome: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
};

CurricularEquivalenceCard.defaultProps = {
  className: '',
};

export default CurricularEquivalenceCard;
